import type { IEventAggregationService } from "@studyportals/event-aggregation-service-interface";

export const useEventAggregationService = (): IEventAggregationService | undefined => {
	if (!import.meta.client) return;

	const eventAggregationService: IEventAggregationService | undefined =
		(window as Record<string, any>)['EventAggregationService'] as IEventAggregationService;

	if (!eventAggregationService) {
		console.warn('EventAggregationService not available, load it');
		return;
	}

	return eventAggregationService;
}